<template>
    <section>
        <div class="goBack pc" @click="linkTo('inicio')">
            <svg xmlns="http://www.w3.org/2000/svg" width="7" height="15" viewBox="0 0 7 15" fill="none">
                <path d="M6 0.500122L1 7.50012L6 14.5001" stroke="#464D5B" stroke-linecap="round" />
            </svg>
            <p>Clases</p>
        </div>
        <div v-if="showClasses === false" class="mov goBack" @click="linkTo('inicio')">
            <svg xmlns="http://www.w3.org/2000/svg" width="7" height="15" viewBox="0 0 7 15" fill="none">
                <path d="M6 0.500122L1 7.50012L6 14.5001" stroke="#464D5B" stroke-linecap="round" />
            </svg>
            <p>Clases</p>
        </div>
        <div v-else class="mov goBack" @click="showClasses = false">
            <svg xmlns="http://www.w3.org/2000/svg" width="7" height="15" viewBox="0 0 7 15" fill="none">
                <path d="M6 0.500122L1 7.50012L6 14.5001" stroke="#464D5B" stroke-linecap="round" />
            </svg>
            <p>{{ this.$route.query.cN || this.$route.query.search || 'Lista de clases' }}</p>
        </div>
        <hr class="mov">
        <div class="classListHead">
            <form class="search" :class="{ 'hideOnTop': showClasses === true }" @submit.prevent="searchItem()">
                <input v-model="searchInput" placeholder="Buscar clase" type="text">
                <button>
                    <svg xmlns="http://www.w3.org/2000/svg" width="35" height="36" viewBox="0 0 35 36" fill="none">
                        <mask id="mask0_1409_4069" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0"
                            width="35" height="36">
                            <rect y="0.500122" width="35" height="35" fill="#D9D9D9" />
                        </mask>
                        <g mask="url(#mask0_1409_4069)">
                            <path
                                d="M28.8488 30.872L19.7705 21.7934C19.0478 22.3901 18.2166 22.8571 17.2771 23.1944C16.3376 23.5316 15.3657 23.7003 14.3613 23.7003C11.8909 23.7003 9.80007 22.845 8.08893 21.1343C6.37779 19.4237 5.52222 17.3334 5.52222 14.8634C5.52222 12.3937 6.37755 10.3027 8.0882 8.5904C9.79886 6.87832 11.8892 6.02228 14.3592 6.02228C16.8289 6.02228 18.92 6.87783 20.6323 8.58895C22.3444 10.3001 23.2005 12.3908 23.2005 14.8613C23.2005 15.8935 23.0273 16.8794 22.6808 17.8189C22.3342 18.7584 21.8718 19.5756 21.2936 20.2703L30.3719 29.3485L28.8488 30.872ZM14.3613 21.5325C16.2238 21.5325 17.8012 20.8862 19.0937 19.5935C20.3863 18.3011 21.0327 16.7237 21.0327 14.8613C21.0327 12.9989 20.3863 11.4215 19.0937 10.129C17.8012 8.83635 16.2238 8.19002 14.3613 8.19002C12.4989 8.19002 10.9215 8.83635 9.62902 10.129C8.33633 11.4215 7.68999 12.9989 7.68999 14.8613C7.68999 16.7237 8.33633 18.3011 9.62902 19.5935C10.9215 20.8862 12.4989 21.5325 14.3613 21.5325Z"
                                fill="url(#paint0_linear_1409_4069)" />
                        </g>
                        <defs>
                            <linearGradient id="paint0_linear_1409_4069" x1="5.52222" y1="18.4471" x2="30.3719"
                                y2="18.4471" gradientUnits="userSpaceOnUse">
                                <stop offset="0.23516" stop-color="#4536EF" />
                                <stop offset="0.913242" stop-color="#FF00B8" />
                            </linearGradient>
                        </defs>
                    </svg>
                </button>
            </form>
            <div class="listInfo">
                <p v-if="$route.query.search">Mostrando resultados de busqueda "{{ deNormalizeText($route.query.search)
                }}"</p>
                <p v-else-if="$route.query.c">Mostrando "{{ deNormalizeText($route.query.cN)
                }}"</p>
                <p v-else>Mostrando todas las clases</p>

                <p v-if="allClases.quantity !== 0">{{ allClases.quantity || '' }} clases encontradas</p>
                <button @click="removeSearch()" v-if="$route.query.search" class="searchThing">
                    <p>{{ deNormalizeText($route.query.search) }}</p>
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                        <path d="M1 1L11 11M11 1L1 11" stroke="#B359F8" stroke-linecap="round" />
                    </svg>
                </button>
            </div>
        </div>
        <div class="classListCont">
            <div class="filters" :class="{ 'hideThisSection': showClasses === true }">
                <!--<h5>Más relevantes</h5>
                 <div class="filtersRelevant">
                    <button class="relevantFilter" v-for="filters in filterTop"
                        :class="{ 'spetial': filters.destacado === true }">
                        <img v-if="filters.icon" :src="filters.icon" alt="">
                        <p>{{ filters.name }}</p>
                    </button>
                </div> -->
                <h5>Todas las categorías:</h5>
                <div class="cardInfo">
                    <div class="cardInfoHead">
                        <button @click="clearCategoryAndShowClasses()">
                            <p>Todas las clases</p>

                            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="16" viewBox="0 0 8 16"
                                fill="none">
                                <path d="M1.5 15.0001L6.5 8.00012L1.5 1.00012" stroke="#B359F8" stroke-width="1.5"
                                    stroke-linecap="round" />
                            </svg>
                        </button>
                        <button v-for="cat in bienvenida" @click="showClasses = true, navigateToCategory(cat)">
                            <p>Bienvenida</p>

                            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="16" viewBox="0 0 8 16"
                                fill="none">
                                <path d="M1.5 15.0001L6.5 8.00012L1.5 1.00012" stroke="#B359F8" stroke-width="1.5"
                                    stroke-linecap="round" />
                            </svg>
                        </button>
                    </div>
                    <div class="catList">
                        <div v-if="cat.name !== 'Bienvenida' && cat.name !== 'JUEVES 29 -'" class="cat"
                            v-for="cat in categoriesQuery" :class="{ 'featured': cat.featured }">
                            <img v-if="cat.image === '' || null" :src="srcImgCat(cat.image)" alt="">
                            <img v-else src="../../assets/tempIcon.svg" alt="">
                            <div class="catNames">
                                <p>{{ cat.name }} </p>

                                <template v-if="cat.secName">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="17" viewBox="0 0 15 17"
                                        fill="none">
                                        <path
                                            d="M7.5 0.00012207C8.47633 0.00012207 8.9645 0.69733 8.9645 2.09174C8.9645 2.71478 8.90533 3.44166 8.78698 4.27237L8.60947 5.42944C8.5503 5.9338 8.50592 6.24532 8.47633 6.364L8.38757 6.94253L10.5178 5.25143C11.9083 4.12403 12.9142 3.56033 13.5355 3.56033C14.1568 3.56033 14.5858 3.79768 14.8225 4.27237C14.9408 4.45038 15 4.65806 15 4.89541C15 5.54812 14.6598 6.08215 13.9793 6.49751C13.3284 6.88319 12.4408 7.28372 11.3166 7.69907L9.31953 8.50012L11.8047 9.47918C12.6923 9.8352 13.3432 10.1467 13.7574 10.4137C14.5858 10.8588 15 11.4225 15 12.1048C15 12.3125 14.8964 12.5944 14.6893 12.9504C14.5118 13.2767 14.1272 13.4399 13.5355 13.4399C12.9438 13.4399 11.9379 12.8762 10.5178 11.7488L8.38757 10.0577L8.47633 10.7253C8.47633 10.8736 8.52071 11.1703 8.60947 11.6153L8.87574 13.1729C8.93491 13.7663 8.9645 14.3596 8.9645 14.953C8.9645 15.5167 8.83136 16.0062 8.56509 16.4216C8.3284 16.8073 7.97337 17.0001 7.5 17.0001C7.02663 17.0001 6.6568 16.8073 6.39053 16.4216C6.15385 16.0062 6.0355 15.5019 6.0355 14.9085C6.0355 14.2855 6.09467 13.5586 6.21302 12.7279L6.39053 11.5708C6.4497 11.0664 6.49408 10.7549 6.52367 10.6362L6.61243 10.0577L4.48225 11.7488C3.09172 12.8762 2.0858 13.4399 1.4645 13.4399C0.843195 13.4399 0.414201 13.2026 0.177515 12.7279C0.0591716 12.5499 0 12.3422 0 12.1048C0 11.4521 0.325444 10.9329 0.976331 10.5472C1.6568 10.1319 2.55917 9.71653 3.68343 9.30117L5.68047 8.50012L3.19527 7.52107C2.33728 7.19471 1.6716 6.88319 1.19822 6.58651C0.399408 6.11182 0 5.54812 0 4.89541C0 4.68773 0.0887574 4.42072 0.266272 4.09436C0.473373 3.73834 0.798816 3.56033 1.2426 3.56033C1.71598 3.56033 2.18935 3.70867 2.66272 4.00536C3.13609 4.27237 3.7426 4.68773 4.48225 5.25143L6.61243 6.94253L6.52367 6.27499C6.52367 6.12665 6.47929 5.82996 6.39053 5.38494L6.12426 3.82735C6.06509 3.23398 6.0355 2.64061 6.0355 2.04724C6.0355 1.42421 6.15385 0.934677 6.39053 0.578657C6.6568 0.192967 7.02663 0.00012207 7.5 0.00012207Z"
                                            fill="#96FF11" />
                                    </svg>
                                    <span v-if="!cat.featured" class="fullW">{{ cat.secName }}</span>
                                </template>

                            </div>
                            <button class="margLeft" @click="navigateToCategory(cat)">
                                <specialButtonMicro />
                            </button>
                        </div>
                    </div>
                    <div class="seeMore">

                        <template v-if="maxCat === 6">
                            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="8" viewBox="0 0 17 8"
                                fill="none">
                                <path d="M1.5 1.50006L8.5 6.50006L15.5 1.50006" stroke="#B359F8" stroke-width="1.5"
                                    stroke-linecap="round" />
                            </svg>
                            <p>scroll</p>
                        </template>

                    </div>
                </div>
            </div>
            <div v-if="this.$route.query.c" :class="{ 'hideThisSection': showClasses === false }" class="titleCard mov">
                <p>{{ this.$route.query.cN }}</p>
                <img src="../../assets/clasesHeaderTemplateMov.png" alt="">
            </div>
            <form :class="{ 'hideThisSection': showClasses === false }" class="search mov"
                @submit.prevent="searchItem()">
                <input v-model="searchInput" placeholder="Buscar clase" type="text">
                <button>
                    <svg xmlns="http://www.w3.org/2000/svg" width="35" height="36" viewBox="0 0 35 36" fill="none">
                        <mask id="mask0_1409_4069" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0"
                            width="35" height="36">
                            <rect y="0.500122" width="35" height="35" fill="#D9D9D9" />
                        </mask>
                        <g mask="url(#mask0_1409_4069)">
                            <path
                                d="M28.8488 30.872L19.7705 21.7934C19.0478 22.3901 18.2166 22.8571 17.2771 23.1944C16.3376 23.5316 15.3657 23.7003 14.3613 23.7003C11.8909 23.7003 9.80007 22.845 8.08893 21.1343C6.37779 19.4237 5.52222 17.3334 5.52222 14.8634C5.52222 12.3937 6.37755 10.3027 8.0882 8.5904C9.79886 6.87832 11.8892 6.02228 14.3592 6.02228C16.8289 6.02228 18.92 6.87783 20.6323 8.58895C22.3444 10.3001 23.2005 12.3908 23.2005 14.8613C23.2005 15.8935 23.0273 16.8794 22.6808 17.8189C22.3342 18.7584 21.8718 19.5756 21.2936 20.2703L30.3719 29.3485L28.8488 30.872ZM14.3613 21.5325C16.2238 21.5325 17.8012 20.8862 19.0937 19.5935C20.3863 18.3011 21.0327 16.7237 21.0327 14.8613C21.0327 12.9989 20.3863 11.4215 19.0937 10.129C17.8012 8.83635 16.2238 8.19002 14.3613 8.19002C12.4989 8.19002 10.9215 8.83635 9.62902 10.129C8.33633 11.4215 7.68999 12.9989 7.68999 14.8613C7.68999 16.7237 8.33633 18.3011 9.62902 19.5935C10.9215 20.8862 12.4989 21.5325 14.3613 21.5325Z"
                                fill="url(#paint0_linear_1409_4069)" />
                        </g>
                        <defs>
                            <linearGradient id="paint0_linear_1409_4069" x1="5.52222" y1="18.4471" x2="30.3719"
                                y2="18.4471" gradientUnits="userSpaceOnUse">
                                <stop offset="0.23516" stop-color="#4536EF" />
                                <stop offset="0.913242" stop-color="#FF00B8" />
                            </linearGradient>
                        </defs>
                    </svg>
                </button>
            </form>
            <div class="clasesList" :class="{ 'hideThisSection': showClasses === false }">

                <div class="notFound" v-if="cumulativeClases.length === 0">


                    <svg xmlns="http://www.w3.org/2000/svg" width="119" height="119" viewBox="0 0 119 119" fill="none">
                        <mask id="mask0_4056_7866" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0"
                            width="119" height="119">
                            <rect x="0.460693" y="0.00012207" width="118.079" height="118.079" fill="#D9D9D9" />
                        </mask>
                        <g mask="url(#mask0_4056_7866)">
                            <path
                                d="M40.3293 18.0902L47.0792 27.3856M78.8349 18.0902L72.085 27.3856M90.8247 35.4785L78.7942 38.99M40.379 38.9534L28.457 35.4785M59.503 12L59.5301 22.8088M69.1057 73.5425L70.367 84.5937C70.575 86.4271 71.6013 88.0686 73.1475 89.0516L82.7818 95.1647C83.7764 95.7957 84.8841 96.0975 85.9736 96.0975C87.9765 96.0975 89.9341 95.087 91.0779 93.2444C92.8456 90.3959 91.9957 86.642 89.1791 84.8543L81.9951 80.2957L81.0638 72.148C80.2862 65.3536 74.6032 60.2281 67.8352 60.2281H51.1391C44.3756 60.2281 38.6881 65.3536 37.9105 72.1526L36.9792 80.3003L29.9444 84.7628C27.1233 86.5506 26.1196 90.3227 27.8602 93.1941C28.9995 95.0687 30.9752 96.102 32.9961 96.102C34.0902 96.102 35.1934 95.8003 36.188 95.1693L45.8223 89.0562C47.3685 88.0732 48.3948 86.4317 48.6028 84.5982L49.8641 73.5471M29.8947 95.2242C28.4073 96.925 27.7789 99.3392 28.4434 101.685C29.2979 104.716 32.0286 106.691 34.9989 106.691H59.9777M89.0977 95.2104C90.4902 96.7924 91.1457 99.0054 90.671 101.241C89.9929 104.46 87.0768 106.691 83.8262 106.691H57.2108C54.1546 106.691 51.6771 104.186 51.6771 101.095C51.6771 98.0041 54.1546 95.4985 57.2108 95.4985H68.3054M59.5843 53.8956C54.0009 53.8956 49.4753 49.3187 49.4753 43.672C49.4753 38.0253 54.0009 33.4484 59.5843 33.4484C65.1678 33.4484 69.6934 38.0253 69.6934 43.672C69.6889 49.3233 65.1633 53.8956 59.5843 53.8956Z"
                                stroke="url(#paint0_linear_4056_7866)" stroke-width="4" stroke-miterlimit="10"
                                stroke-linecap="round" stroke-linejoin="round" />
                        </g>
                        <defs>
                            <linearGradient id="paint0_linear_4056_7866" x1="27" y1="59.3457" x2="92" y2="59.3457"
                                gradientUnits="userSpaceOnUse">
                                <stop offset="0.23516" stop-color="#4536EF" />
                                <stop offset="0.913242" stop-color="#FF00B8" />
                            </linearGradient>
                        </defs>
                    </svg>

                    <p v-if="$route.query.search">No se han encontrado resultados de la búsqueda "{{
                        deNormalizeText($route.query.search) }}"</p>

                    <p v-else>No se han encontrado clases</p>

                    <button v-if="$route.query.search" @click="removeSearch()">regresar</button>
                </div>
                <template v-else>
                    <div class="claseCard" v-for="clase in cumulativeClases" :class="{ 'bloqueada': clase.locked }">

                        <div @click="goToClass(clase.title, clase.id, clase.locked)" class="claseCardImg">
                            <button class="clasePlay">
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="23" viewBox="0 0 14 23"
                                    fill="none">
                                    <path
                                        d="M1 20.6567V2.34352C1 1.46284 2.05606 1.01218 2.69191 1.62153L12.2466 10.7781C12.6574 11.1718 12.6574 11.8284 12.2466 12.2221L2.69191 21.3787C2.05606 21.9881 1 21.5374 1 20.6567Z"
                                        stroke="white" />
                                </svg>
                            </button>
                            <div class="claseDificulty">
                                <template v-if="clase.intensity === 'Baja'">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13"
                                        fill="none">
                                        <path
                                            d="M1.85 7.46216C1.85 8.20621 2.02655 8.89871 2.37965 9.53963C2.73263 10.1806 3.21797 10.6974 3.83568 11.0903C3.78117 10.9861 3.74212 10.8822 3.71853 10.7785C3.69507 10.6749 3.68333 10.5662 3.68333 10.4527C3.68333 10.1109 3.74848 9.78903 3.87877 9.48702C4.00893 9.18502 4.19575 8.91144 4.43922 8.6663L6.25 6.87292L8.06775 8.6663C8.31134 8.91144 8.49706 9.18502 8.6249 9.48702C8.75274 9.78903 8.81667 10.1109 8.81667 10.4527C8.81667 10.5662 8.80493 10.6749 8.78147 10.7785C8.75788 10.8822 8.71883 10.9861 8.66432 11.0903C9.28203 10.6974 9.76737 10.1806 10.1203 9.53963C10.4735 8.89871 10.65 8.20621 10.65 7.46216C10.65 6.84683 10.5369 6.26534 10.3108 5.7177C10.0847 5.17006 9.75778 4.68087 9.33 4.25014C9.08556 4.41013 8.82889 4.53011 8.56 4.61011C8.29111 4.6901 8.01611 4.7301 7.735 4.7301C6.97258 4.7301 6.31331 4.47781 5.7572 3.97324C5.20109 3.46867 4.88258 2.84245 4.80167 2.09458C4.325 2.49602 3.90333 2.91518 3.53667 3.35207C3.17 3.78895 2.86139 4.23433 2.61083 4.68819C2.36028 5.14218 2.17083 5.603 2.0425 6.07065C1.91417 6.5383 1.85 7.00214 1.85 7.46216ZM6.25 8.42207L5.205 9.45583C5.07056 9.5912 4.96667 9.74503 4.89333 9.91732C4.82 10.0896 4.78333 10.2681 4.78333 10.4527C4.78333 10.8465 4.92694 11.1849 5.21417 11.468C5.50139 11.751 5.84667 11.8925 6.25 11.8925C6.65333 11.8925 6.99861 11.751 7.28583 11.468C7.57306 11.1849 7.71667 10.8465 7.71667 10.4527C7.71667 10.2558 7.68 10.0742 7.60667 9.90809C7.53333 9.74195 7.42944 9.5912 7.295 9.45583L6.25 8.42207ZM5.88333 0.00012207V1.77652C5.88333 2.29905 6.06221 2.73735 6.41995 3.09141C6.77769 3.44547 7.21604 3.6225 7.735 3.6225C7.95964 3.6225 8.17378 3.57992 8.3774 3.49476C8.5809 3.4096 8.76778 3.28413 8.93803 3.11836L9.26088 2.79052C10.0337 3.28844 10.6417 3.95275 11.085 4.78345C11.5283 5.61414 11.75 6.50704 11.75 7.46216C11.75 9.00713 11.2169 10.3164 10.1508 11.3899C9.08464 12.4634 7.78438 13.0001 6.25 13.0001C4.71562 13.0001 3.41536 12.4634 2.34922 11.3899C1.28307 10.3164 0.75 9.00713 0.75 7.46216C0.75 6.03558 1.21163 4.6629 2.1349 3.34413C3.05817 2.02548 4.30764 0.910809 5.88333 0.00012207Z"
                                            fill="url(#paint0_linear_3899_5474)" />
                                        <defs>
                                            <linearGradient id="paint0_linear_3899_5474" x1="0.75" y1="6.50012"
                                                x2="11.75" y2="6.50012" gradientUnits="userSpaceOnUse">
                                                <stop offset="0.23516" stop-color="#4536EF" />
                                                <stop offset="0.913242" stop-color="#FF00B8" />
                                            </linearGradient>
                                        </defs>
                                    </svg>
                                    <svg class="disabled" xmlns="http://www.w3.org/2000/svg" width="12" height="13"
                                        viewBox="0 0 12 13" fill="none">
                                        <path
                                            d="M1.85 7.46216C1.85 8.20621 2.02655 8.89871 2.37965 9.53963C2.73263 10.1806 3.21797 10.6974 3.83568 11.0903C3.78117 10.9861 3.74212 10.8822 3.71853 10.7785C3.69507 10.6749 3.68333 10.5662 3.68333 10.4527C3.68333 10.1109 3.74848 9.78903 3.87877 9.48702C4.00893 9.18502 4.19575 8.91144 4.43922 8.6663L6.25 6.87292L8.06775 8.6663C8.31134 8.91144 8.49706 9.18502 8.6249 9.48702C8.75274 9.78903 8.81667 10.1109 8.81667 10.4527C8.81667 10.5662 8.80493 10.6749 8.78147 10.7785C8.75788 10.8822 8.71883 10.9861 8.66432 11.0903C9.28203 10.6974 9.76737 10.1806 10.1203 9.53963C10.4735 8.89871 10.65 8.20621 10.65 7.46216C10.65 6.84683 10.5369 6.26534 10.3108 5.7177C10.0847 5.17006 9.75778 4.68087 9.33 4.25014C9.08556 4.41013 8.82889 4.53011 8.56 4.61011C8.29111 4.6901 8.01611 4.7301 7.735 4.7301C6.97258 4.7301 6.31331 4.47781 5.7572 3.97324C5.20109 3.46867 4.88258 2.84245 4.80167 2.09458C4.325 2.49602 3.90333 2.91518 3.53667 3.35207C3.17 3.78895 2.86139 4.23433 2.61083 4.68819C2.36028 5.14218 2.17083 5.603 2.0425 6.07065C1.91417 6.5383 1.85 7.00214 1.85 7.46216ZM6.25 8.42207L5.205 9.45583C5.07056 9.5912 4.96667 9.74503 4.89333 9.91732C4.82 10.0896 4.78333 10.2681 4.78333 10.4527C4.78333 10.8465 4.92694 11.1849 5.21417 11.468C5.50139 11.751 5.84667 11.8925 6.25 11.8925C6.65333 11.8925 6.99861 11.751 7.28583 11.468C7.57306 11.1849 7.71667 10.8465 7.71667 10.4527C7.71667 10.2558 7.68 10.0742 7.60667 9.90809C7.53333 9.74195 7.42944 9.5912 7.295 9.45583L6.25 8.42207ZM5.88333 0.00012207V1.77652C5.88333 2.29905 6.06221 2.73735 6.41995 3.09141C6.77769 3.44547 7.21604 3.6225 7.735 3.6225C7.95964 3.6225 8.17378 3.57992 8.3774 3.49476C8.5809 3.4096 8.76778 3.28413 8.93803 3.11836L9.26088 2.79052C10.0337 3.28844 10.6417 3.95275 11.085 4.78345C11.5283 5.61414 11.75 6.50704 11.75 7.46216C11.75 9.00713 11.2169 10.3164 10.1508 11.3899C9.08464 12.4634 7.78438 13.0001 6.25 13.0001C4.71562 13.0001 3.41536 12.4634 2.34922 11.3899C1.28307 10.3164 0.75 9.00713 0.75 7.46216C0.75 6.03558 1.21163 4.6629 2.1349 3.34413C3.05817 2.02548 4.30764 0.910809 5.88333 0.00012207Z"
                                            fill="url(#paint0_linear_3899_5474)" />
                                        <defs>
                                            <linearGradient id="paint0_linear_3899_5474" x1="0.75" y1="6.50012"
                                                x2="11.75" y2="6.50012" gradientUnits="userSpaceOnUse">
                                                <stop offset="0.23516" stop-color="#4536EF" />
                                                <stop offset="0.913242" stop-color="#FF00B8" />
                                            </linearGradient>
                                        </defs>
                                    </svg>
                                    <svg class="disabled" xmlns="http://www.w3.org/2000/svg" width="12" height="13"
                                        viewBox="0 0 12 13" fill="none">
                                        <path
                                            d="M1.85 7.46216C1.85 8.20621 2.02655 8.89871 2.37965 9.53963C2.73263 10.1806 3.21797 10.6974 3.83568 11.0903C3.78117 10.9861 3.74212 10.8822 3.71853 10.7785C3.69507 10.6749 3.68333 10.5662 3.68333 10.4527C3.68333 10.1109 3.74848 9.78903 3.87877 9.48702C4.00893 9.18502 4.19575 8.91144 4.43922 8.6663L6.25 6.87292L8.06775 8.6663C8.31134 8.91144 8.49706 9.18502 8.6249 9.48702C8.75274 9.78903 8.81667 10.1109 8.81667 10.4527C8.81667 10.5662 8.80493 10.6749 8.78147 10.7785C8.75788 10.8822 8.71883 10.9861 8.66432 11.0903C9.28203 10.6974 9.76737 10.1806 10.1203 9.53963C10.4735 8.89871 10.65 8.20621 10.65 7.46216C10.65 6.84683 10.5369 6.26534 10.3108 5.7177C10.0847 5.17006 9.75778 4.68087 9.33 4.25014C9.08556 4.41013 8.82889 4.53011 8.56 4.61011C8.29111 4.6901 8.01611 4.7301 7.735 4.7301C6.97258 4.7301 6.31331 4.47781 5.7572 3.97324C5.20109 3.46867 4.88258 2.84245 4.80167 2.09458C4.325 2.49602 3.90333 2.91518 3.53667 3.35207C3.17 3.78895 2.86139 4.23433 2.61083 4.68819C2.36028 5.14218 2.17083 5.603 2.0425 6.07065C1.91417 6.5383 1.85 7.00214 1.85 7.46216ZM6.25 8.42207L5.205 9.45583C5.07056 9.5912 4.96667 9.74503 4.89333 9.91732C4.82 10.0896 4.78333 10.2681 4.78333 10.4527C4.78333 10.8465 4.92694 11.1849 5.21417 11.468C5.50139 11.751 5.84667 11.8925 6.25 11.8925C6.65333 11.8925 6.99861 11.751 7.28583 11.468C7.57306 11.1849 7.71667 10.8465 7.71667 10.4527C7.71667 10.2558 7.68 10.0742 7.60667 9.90809C7.53333 9.74195 7.42944 9.5912 7.295 9.45583L6.25 8.42207ZM5.88333 0.00012207V1.77652C5.88333 2.29905 6.06221 2.73735 6.41995 3.09141C6.77769 3.44547 7.21604 3.6225 7.735 3.6225C7.95964 3.6225 8.17378 3.57992 8.3774 3.49476C8.5809 3.4096 8.76778 3.28413 8.93803 3.11836L9.26088 2.79052C10.0337 3.28844 10.6417 3.95275 11.085 4.78345C11.5283 5.61414 11.75 6.50704 11.75 7.46216C11.75 9.00713 11.2169 10.3164 10.1508 11.3899C9.08464 12.4634 7.78438 13.0001 6.25 13.0001C4.71562 13.0001 3.41536 12.4634 2.34922 11.3899C1.28307 10.3164 0.75 9.00713 0.75 7.46216C0.75 6.03558 1.21163 4.6629 2.1349 3.34413C3.05817 2.02548 4.30764 0.910809 5.88333 0.00012207Z"
                                            fill="url(#paint0_linear_3899_5474)" />
                                        <defs>
                                            <linearGradient id="paint0_linear_3899_5474" x1="0.75" y1="6.50012"
                                                x2="11.75" y2="6.50012" gradientUnits="userSpaceOnUse">
                                                <stop offset="0.23516" stop-color="#4536EF" />
                                                <stop offset="0.913242" stop-color="#FF00B8" />
                                            </linearGradient>
                                        </defs>
                                    </svg>
                                </template>
                                <template v-if="clase.intensity === 'Media'">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13"
                                        fill="none">
                                        <path
                                            d="M1.85 7.46216C1.85 8.20621 2.02655 8.89871 2.37965 9.53963C2.73263 10.1806 3.21797 10.6974 3.83568 11.0903C3.78117 10.9861 3.74212 10.8822 3.71853 10.7785C3.69507 10.6749 3.68333 10.5662 3.68333 10.4527C3.68333 10.1109 3.74848 9.78903 3.87877 9.48702C4.00893 9.18502 4.19575 8.91144 4.43922 8.6663L6.25 6.87292L8.06775 8.6663C8.31134 8.91144 8.49706 9.18502 8.6249 9.48702C8.75274 9.78903 8.81667 10.1109 8.81667 10.4527C8.81667 10.5662 8.80493 10.6749 8.78147 10.7785C8.75788 10.8822 8.71883 10.9861 8.66432 11.0903C9.28203 10.6974 9.76737 10.1806 10.1203 9.53963C10.4735 8.89871 10.65 8.20621 10.65 7.46216C10.65 6.84683 10.5369 6.26534 10.3108 5.7177C10.0847 5.17006 9.75778 4.68087 9.33 4.25014C9.08556 4.41013 8.82889 4.53011 8.56 4.61011C8.29111 4.6901 8.01611 4.7301 7.735 4.7301C6.97258 4.7301 6.31331 4.47781 5.7572 3.97324C5.20109 3.46867 4.88258 2.84245 4.80167 2.09458C4.325 2.49602 3.90333 2.91518 3.53667 3.35207C3.17 3.78895 2.86139 4.23433 2.61083 4.68819C2.36028 5.14218 2.17083 5.603 2.0425 6.07065C1.91417 6.5383 1.85 7.00214 1.85 7.46216ZM6.25 8.42207L5.205 9.45583C5.07056 9.5912 4.96667 9.74503 4.89333 9.91732C4.82 10.0896 4.78333 10.2681 4.78333 10.4527C4.78333 10.8465 4.92694 11.1849 5.21417 11.468C5.50139 11.751 5.84667 11.8925 6.25 11.8925C6.65333 11.8925 6.99861 11.751 7.28583 11.468C7.57306 11.1849 7.71667 10.8465 7.71667 10.4527C7.71667 10.2558 7.68 10.0742 7.60667 9.90809C7.53333 9.74195 7.42944 9.5912 7.295 9.45583L6.25 8.42207ZM5.88333 0.00012207V1.77652C5.88333 2.29905 6.06221 2.73735 6.41995 3.09141C6.77769 3.44547 7.21604 3.6225 7.735 3.6225C7.95964 3.6225 8.17378 3.57992 8.3774 3.49476C8.5809 3.4096 8.76778 3.28413 8.93803 3.11836L9.26088 2.79052C10.0337 3.28844 10.6417 3.95275 11.085 4.78345C11.5283 5.61414 11.75 6.50704 11.75 7.46216C11.75 9.00713 11.2169 10.3164 10.1508 11.3899C9.08464 12.4634 7.78438 13.0001 6.25 13.0001C4.71562 13.0001 3.41536 12.4634 2.34922 11.3899C1.28307 10.3164 0.75 9.00713 0.75 7.46216C0.75 6.03558 1.21163 4.6629 2.1349 3.34413C3.05817 2.02548 4.30764 0.910809 5.88333 0.00012207Z"
                                            fill="url(#paint0_linear_3899_5474)" />
                                        <defs>
                                            <linearGradient id="paint0_linear_3899_5474" x1="0.75" y1="6.50012"
                                                x2="11.75" y2="6.50012" gradientUnits="userSpaceOnUse">
                                                <stop offset="0.23516" stop-color="#4536EF" />
                                                <stop offset="0.913242" stop-color="#FF00B8" />
                                            </linearGradient>
                                        </defs>
                                    </svg>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13"
                                        fill="none">
                                        <path
                                            d="M1.85 7.46216C1.85 8.20621 2.02655 8.89871 2.37965 9.53963C2.73263 10.1806 3.21797 10.6974 3.83568 11.0903C3.78117 10.9861 3.74212 10.8822 3.71853 10.7785C3.69507 10.6749 3.68333 10.5662 3.68333 10.4527C3.68333 10.1109 3.74848 9.78903 3.87877 9.48702C4.00893 9.18502 4.19575 8.91144 4.43922 8.6663L6.25 6.87292L8.06775 8.6663C8.31134 8.91144 8.49706 9.18502 8.6249 9.48702C8.75274 9.78903 8.81667 10.1109 8.81667 10.4527C8.81667 10.5662 8.80493 10.6749 8.78147 10.7785C8.75788 10.8822 8.71883 10.9861 8.66432 11.0903C9.28203 10.6974 9.76737 10.1806 10.1203 9.53963C10.4735 8.89871 10.65 8.20621 10.65 7.46216C10.65 6.84683 10.5369 6.26534 10.3108 5.7177C10.0847 5.17006 9.75778 4.68087 9.33 4.25014C9.08556 4.41013 8.82889 4.53011 8.56 4.61011C8.29111 4.6901 8.01611 4.7301 7.735 4.7301C6.97258 4.7301 6.31331 4.47781 5.7572 3.97324C5.20109 3.46867 4.88258 2.84245 4.80167 2.09458C4.325 2.49602 3.90333 2.91518 3.53667 3.35207C3.17 3.78895 2.86139 4.23433 2.61083 4.68819C2.36028 5.14218 2.17083 5.603 2.0425 6.07065C1.91417 6.5383 1.85 7.00214 1.85 7.46216ZM6.25 8.42207L5.205 9.45583C5.07056 9.5912 4.96667 9.74503 4.89333 9.91732C4.82 10.0896 4.78333 10.2681 4.78333 10.4527C4.78333 10.8465 4.92694 11.1849 5.21417 11.468C5.50139 11.751 5.84667 11.8925 6.25 11.8925C6.65333 11.8925 6.99861 11.751 7.28583 11.468C7.57306 11.1849 7.71667 10.8465 7.71667 10.4527C7.71667 10.2558 7.68 10.0742 7.60667 9.90809C7.53333 9.74195 7.42944 9.5912 7.295 9.45583L6.25 8.42207ZM5.88333 0.00012207V1.77652C5.88333 2.29905 6.06221 2.73735 6.41995 3.09141C6.77769 3.44547 7.21604 3.6225 7.735 3.6225C7.95964 3.6225 8.17378 3.57992 8.3774 3.49476C8.5809 3.4096 8.76778 3.28413 8.93803 3.11836L9.26088 2.79052C10.0337 3.28844 10.6417 3.95275 11.085 4.78345C11.5283 5.61414 11.75 6.50704 11.75 7.46216C11.75 9.00713 11.2169 10.3164 10.1508 11.3899C9.08464 12.4634 7.78438 13.0001 6.25 13.0001C4.71562 13.0001 3.41536 12.4634 2.34922 11.3899C1.28307 10.3164 0.75 9.00713 0.75 7.46216C0.75 6.03558 1.21163 4.6629 2.1349 3.34413C3.05817 2.02548 4.30764 0.910809 5.88333 0.00012207Z"
                                            fill="url(#paint0_linear_3899_5474)" />
                                        <defs>
                                            <linearGradient id="paint0_linear_3899_5474" x1="0.75" y1="6.50012"
                                                x2="11.75" y2="6.50012" gradientUnits="userSpaceOnUse">
                                                <stop offset="0.23516" stop-color="#4536EF" />
                                                <stop offset="0.913242" stop-color="#FF00B8" />
                                            </linearGradient>
                                        </defs>
                                    </svg>
                                    <svg class="disabled" xmlns="http://www.w3.org/2000/svg" width="12" height="13"
                                        viewBox="0 0 12 13" fill="none">
                                        <path
                                            d="M1.85 7.46216C1.85 8.20621 2.02655 8.89871 2.37965 9.53963C2.73263 10.1806 3.21797 10.6974 3.83568 11.0903C3.78117 10.9861 3.74212 10.8822 3.71853 10.7785C3.69507 10.6749 3.68333 10.5662 3.68333 10.4527C3.68333 10.1109 3.74848 9.78903 3.87877 9.48702C4.00893 9.18502 4.19575 8.91144 4.43922 8.6663L6.25 6.87292L8.06775 8.6663C8.31134 8.91144 8.49706 9.18502 8.6249 9.48702C8.75274 9.78903 8.81667 10.1109 8.81667 10.4527C8.81667 10.5662 8.80493 10.6749 8.78147 10.7785C8.75788 10.8822 8.71883 10.9861 8.66432 11.0903C9.28203 10.6974 9.76737 10.1806 10.1203 9.53963C10.4735 8.89871 10.65 8.20621 10.65 7.46216C10.65 6.84683 10.5369 6.26534 10.3108 5.7177C10.0847 5.17006 9.75778 4.68087 9.33 4.25014C9.08556 4.41013 8.82889 4.53011 8.56 4.61011C8.29111 4.6901 8.01611 4.7301 7.735 4.7301C6.97258 4.7301 6.31331 4.47781 5.7572 3.97324C5.20109 3.46867 4.88258 2.84245 4.80167 2.09458C4.325 2.49602 3.90333 2.91518 3.53667 3.35207C3.17 3.78895 2.86139 4.23433 2.61083 4.68819C2.36028 5.14218 2.17083 5.603 2.0425 6.07065C1.91417 6.5383 1.85 7.00214 1.85 7.46216ZM6.25 8.42207L5.205 9.45583C5.07056 9.5912 4.96667 9.74503 4.89333 9.91732C4.82 10.0896 4.78333 10.2681 4.78333 10.4527C4.78333 10.8465 4.92694 11.1849 5.21417 11.468C5.50139 11.751 5.84667 11.8925 6.25 11.8925C6.65333 11.8925 6.99861 11.751 7.28583 11.468C7.57306 11.1849 7.71667 10.8465 7.71667 10.4527C7.71667 10.2558 7.68 10.0742 7.60667 9.90809C7.53333 9.74195 7.42944 9.5912 7.295 9.45583L6.25 8.42207ZM5.88333 0.00012207V1.77652C5.88333 2.29905 6.06221 2.73735 6.41995 3.09141C6.77769 3.44547 7.21604 3.6225 7.735 3.6225C7.95964 3.6225 8.17378 3.57992 8.3774 3.49476C8.5809 3.4096 8.76778 3.28413 8.93803 3.11836L9.26088 2.79052C10.0337 3.28844 10.6417 3.95275 11.085 4.78345C11.5283 5.61414 11.75 6.50704 11.75 7.46216C11.75 9.00713 11.2169 10.3164 10.1508 11.3899C9.08464 12.4634 7.78438 13.0001 6.25 13.0001C4.71562 13.0001 3.41536 12.4634 2.34922 11.3899C1.28307 10.3164 0.75 9.00713 0.75 7.46216C0.75 6.03558 1.21163 4.6629 2.1349 3.34413C3.05817 2.02548 4.30764 0.910809 5.88333 0.00012207Z"
                                            fill="url(#paint0_linear_3899_5474)" />
                                        <defs>
                                            <linearGradient id="paint0_linear_3899_5474" x1="0.75" y1="6.50012"
                                                x2="11.75" y2="6.50012" gradientUnits="userSpaceOnUse">
                                                <stop offset="0.23516" stop-color="#4536EF" />
                                                <stop offset="0.913242" stop-color="#FF00B8" />
                                            </linearGradient>
                                        </defs>
                                    </svg>
                                </template>
                                <template v-if="clase.intensity === 'Alta'">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13"
                                        fill="none">
                                        <path
                                            d="M1.85 7.46216C1.85 8.20621 2.02655 8.89871 2.37965 9.53963C2.73263 10.1806 3.21797 10.6974 3.83568 11.0903C3.78117 10.9861 3.74212 10.8822 3.71853 10.7785C3.69507 10.6749 3.68333 10.5662 3.68333 10.4527C3.68333 10.1109 3.74848 9.78903 3.87877 9.48702C4.00893 9.18502 4.19575 8.91144 4.43922 8.6663L6.25 6.87292L8.06775 8.6663C8.31134 8.91144 8.49706 9.18502 8.6249 9.48702C8.75274 9.78903 8.81667 10.1109 8.81667 10.4527C8.81667 10.5662 8.80493 10.6749 8.78147 10.7785C8.75788 10.8822 8.71883 10.9861 8.66432 11.0903C9.28203 10.6974 9.76737 10.1806 10.1203 9.53963C10.4735 8.89871 10.65 8.20621 10.65 7.46216C10.65 6.84683 10.5369 6.26534 10.3108 5.7177C10.0847 5.17006 9.75778 4.68087 9.33 4.25014C9.08556 4.41013 8.82889 4.53011 8.56 4.61011C8.29111 4.6901 8.01611 4.7301 7.735 4.7301C6.97258 4.7301 6.31331 4.47781 5.7572 3.97324C5.20109 3.46867 4.88258 2.84245 4.80167 2.09458C4.325 2.49602 3.90333 2.91518 3.53667 3.35207C3.17 3.78895 2.86139 4.23433 2.61083 4.68819C2.36028 5.14218 2.17083 5.603 2.0425 6.07065C1.91417 6.5383 1.85 7.00214 1.85 7.46216ZM6.25 8.42207L5.205 9.45583C5.07056 9.5912 4.96667 9.74503 4.89333 9.91732C4.82 10.0896 4.78333 10.2681 4.78333 10.4527C4.78333 10.8465 4.92694 11.1849 5.21417 11.468C5.50139 11.751 5.84667 11.8925 6.25 11.8925C6.65333 11.8925 6.99861 11.751 7.28583 11.468C7.57306 11.1849 7.71667 10.8465 7.71667 10.4527C7.71667 10.2558 7.68 10.0742 7.60667 9.90809C7.53333 9.74195 7.42944 9.5912 7.295 9.45583L6.25 8.42207ZM5.88333 0.00012207V1.77652C5.88333 2.29905 6.06221 2.73735 6.41995 3.09141C6.77769 3.44547 7.21604 3.6225 7.735 3.6225C7.95964 3.6225 8.17378 3.57992 8.3774 3.49476C8.5809 3.4096 8.76778 3.28413 8.93803 3.11836L9.26088 2.79052C10.0337 3.28844 10.6417 3.95275 11.085 4.78345C11.5283 5.61414 11.75 6.50704 11.75 7.46216C11.75 9.00713 11.2169 10.3164 10.1508 11.3899C9.08464 12.4634 7.78438 13.0001 6.25 13.0001C4.71562 13.0001 3.41536 12.4634 2.34922 11.3899C1.28307 10.3164 0.75 9.00713 0.75 7.46216C0.75 6.03558 1.21163 4.6629 2.1349 3.34413C3.05817 2.02548 4.30764 0.910809 5.88333 0.00012207Z"
                                            fill="url(#paint0_linear_3899_5474)" />
                                        <defs>
                                            <linearGradient id="paint0_linear_3899_5474" x1="0.75" y1="6.50012"
                                                x2="11.75" y2="6.50012" gradientUnits="userSpaceOnUse">
                                                <stop offset="0.23516" stop-color="#4536EF" />
                                                <stop offset="0.913242" stop-color="#FF00B8" />
                                            </linearGradient>
                                        </defs>
                                    </svg>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13"
                                        fill="none">
                                        <path
                                            d="M1.85 7.46216C1.85 8.20621 2.02655 8.89871 2.37965 9.53963C2.73263 10.1806 3.21797 10.6974 3.83568 11.0903C3.78117 10.9861 3.74212 10.8822 3.71853 10.7785C3.69507 10.6749 3.68333 10.5662 3.68333 10.4527C3.68333 10.1109 3.74848 9.78903 3.87877 9.48702C4.00893 9.18502 4.19575 8.91144 4.43922 8.6663L6.25 6.87292L8.06775 8.6663C8.31134 8.91144 8.49706 9.18502 8.6249 9.48702C8.75274 9.78903 8.81667 10.1109 8.81667 10.4527C8.81667 10.5662 8.80493 10.6749 8.78147 10.7785C8.75788 10.8822 8.71883 10.9861 8.66432 11.0903C9.28203 10.6974 9.76737 10.1806 10.1203 9.53963C10.4735 8.89871 10.65 8.20621 10.65 7.46216C10.65 6.84683 10.5369 6.26534 10.3108 5.7177C10.0847 5.17006 9.75778 4.68087 9.33 4.25014C9.08556 4.41013 8.82889 4.53011 8.56 4.61011C8.29111 4.6901 8.01611 4.7301 7.735 4.7301C6.97258 4.7301 6.31331 4.47781 5.7572 3.97324C5.20109 3.46867 4.88258 2.84245 4.80167 2.09458C4.325 2.49602 3.90333 2.91518 3.53667 3.35207C3.17 3.78895 2.86139 4.23433 2.61083 4.68819C2.36028 5.14218 2.17083 5.603 2.0425 6.07065C1.91417 6.5383 1.85 7.00214 1.85 7.46216ZM6.25 8.42207L5.205 9.45583C5.07056 9.5912 4.96667 9.74503 4.89333 9.91732C4.82 10.0896 4.78333 10.2681 4.78333 10.4527C4.78333 10.8465 4.92694 11.1849 5.21417 11.468C5.50139 11.751 5.84667 11.8925 6.25 11.8925C6.65333 11.8925 6.99861 11.751 7.28583 11.468C7.57306 11.1849 7.71667 10.8465 7.71667 10.4527C7.71667 10.2558 7.68 10.0742 7.60667 9.90809C7.53333 9.74195 7.42944 9.5912 7.295 9.45583L6.25 8.42207ZM5.88333 0.00012207V1.77652C5.88333 2.29905 6.06221 2.73735 6.41995 3.09141C6.77769 3.44547 7.21604 3.6225 7.735 3.6225C7.95964 3.6225 8.17378 3.57992 8.3774 3.49476C8.5809 3.4096 8.76778 3.28413 8.93803 3.11836L9.26088 2.79052C10.0337 3.28844 10.6417 3.95275 11.085 4.78345C11.5283 5.61414 11.75 6.50704 11.75 7.46216C11.75 9.00713 11.2169 10.3164 10.1508 11.3899C9.08464 12.4634 7.78438 13.0001 6.25 13.0001C4.71562 13.0001 3.41536 12.4634 2.34922 11.3899C1.28307 10.3164 0.75 9.00713 0.75 7.46216C0.75 6.03558 1.21163 4.6629 2.1349 3.34413C3.05817 2.02548 4.30764 0.910809 5.88333 0.00012207Z"
                                            fill="url(#paint0_linear_3899_5474)" />
                                        <defs>
                                            <linearGradient id="paint0_linear_3899_5474" x1="0.75" y1="6.50012"
                                                x2="11.75" y2="6.50012" gradientUnits="userSpaceOnUse">
                                                <stop offset="0.23516" stop-color="#4536EF" />
                                                <stop offset="0.913242" stop-color="#FF00B8" />
                                            </linearGradient>
                                        </defs>
                                    </svg>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13"
                                        fill="none">
                                        <path
                                            d="M1.85 7.46216C1.85 8.20621 2.02655 8.89871 2.37965 9.53963C2.73263 10.1806 3.21797 10.6974 3.83568 11.0903C3.78117 10.9861 3.74212 10.8822 3.71853 10.7785C3.69507 10.6749 3.68333 10.5662 3.68333 10.4527C3.68333 10.1109 3.74848 9.78903 3.87877 9.48702C4.00893 9.18502 4.19575 8.91144 4.43922 8.6663L6.25 6.87292L8.06775 8.6663C8.31134 8.91144 8.49706 9.18502 8.6249 9.48702C8.75274 9.78903 8.81667 10.1109 8.81667 10.4527C8.81667 10.5662 8.80493 10.6749 8.78147 10.7785C8.75788 10.8822 8.71883 10.9861 8.66432 11.0903C9.28203 10.6974 9.76737 10.1806 10.1203 9.53963C10.4735 8.89871 10.65 8.20621 10.65 7.46216C10.65 6.84683 10.5369 6.26534 10.3108 5.7177C10.0847 5.17006 9.75778 4.68087 9.33 4.25014C9.08556 4.41013 8.82889 4.53011 8.56 4.61011C8.29111 4.6901 8.01611 4.7301 7.735 4.7301C6.97258 4.7301 6.31331 4.47781 5.7572 3.97324C5.20109 3.46867 4.88258 2.84245 4.80167 2.09458C4.325 2.49602 3.90333 2.91518 3.53667 3.35207C3.17 3.78895 2.86139 4.23433 2.61083 4.68819C2.36028 5.14218 2.17083 5.603 2.0425 6.07065C1.91417 6.5383 1.85 7.00214 1.85 7.46216ZM6.25 8.42207L5.205 9.45583C5.07056 9.5912 4.96667 9.74503 4.89333 9.91732C4.82 10.0896 4.78333 10.2681 4.78333 10.4527C4.78333 10.8465 4.92694 11.1849 5.21417 11.468C5.50139 11.751 5.84667 11.8925 6.25 11.8925C6.65333 11.8925 6.99861 11.751 7.28583 11.468C7.57306 11.1849 7.71667 10.8465 7.71667 10.4527C7.71667 10.2558 7.68 10.0742 7.60667 9.90809C7.53333 9.74195 7.42944 9.5912 7.295 9.45583L6.25 8.42207ZM5.88333 0.00012207V1.77652C5.88333 2.29905 6.06221 2.73735 6.41995 3.09141C6.77769 3.44547 7.21604 3.6225 7.735 3.6225C7.95964 3.6225 8.17378 3.57992 8.3774 3.49476C8.5809 3.4096 8.76778 3.28413 8.93803 3.11836L9.26088 2.79052C10.0337 3.28844 10.6417 3.95275 11.085 4.78345C11.5283 5.61414 11.75 6.50704 11.75 7.46216C11.75 9.00713 11.2169 10.3164 10.1508 11.3899C9.08464 12.4634 7.78438 13.0001 6.25 13.0001C4.71562 13.0001 3.41536 12.4634 2.34922 11.3899C1.28307 10.3164 0.75 9.00713 0.75 7.46216C0.75 6.03558 1.21163 4.6629 2.1349 3.34413C3.05817 2.02548 4.30764 0.910809 5.88333 0.00012207Z"
                                            fill="url(#paint0_linear_3899_5474)" />
                                        <defs>
                                            <linearGradient id="paint0_linear_3899_5474" x1="0.75" y1="6.50012"
                                                x2="11.75" y2="6.50012" gradientUnits="userSpaceOnUse">
                                                <stop offset="0.23516" stop-color="#4536EF" />
                                                <stop offset="0.913242" stop-color="#FF00B8" />
                                            </linearGradient>
                                        </defs>
                                    </svg>
                                </template>
                            </div>
                            <div class="claseTime" v-if="clase.duration">
                                <p>{{ Math.floor(clase.duration / 60) }}:{{ (clase.duration % 60).toString().padStart(2,
                                    '0') }}</p>
                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12"
                                    fill="none">
                                    <path
                                        d="M6.25303 11.5001C4.71679 11.5001 3.41553 10.967 2.34924 9.90072C1.28308 8.83458 0.75 7.53334 0.75 5.99701C0.75 4.47228 1.28308 3.17496 2.34924 2.10502C3.41553 1.03509 4.71679 0.500122 6.25303 0.500122C7.7779 0.500122 9.07524 1.03509 10.1451 2.10502C11.215 3.17496 11.75 4.47228 11.75 5.99701C11.75 7.53334 11.215 8.83458 10.1451 9.90072C9.07524 10.967 7.7779 11.5001 6.25303 11.5001ZM6.24991 10.4001C7.47215 10.4001 8.51106 9.97234 9.36663 9.11679C10.2222 8.26123 10.65 7.22234 10.65 6.00012C10.65 4.7779 10.2222 3.73901 9.36663 2.88346C8.51106 2.0279 7.47215 1.60012 6.24991 1.60012C5.02767 1.60012 3.98876 2.0279 3.13319 2.88346C2.27762 3.73901 1.84983 4.7779 1.84983 6.00012C1.84983 7.22234 2.27762 8.26123 3.13319 9.11679C3.98876 9.97234 5.02767 10.4001 6.24991 10.4001ZM7.98885 8.54131L8.77298 7.75737L6.79992 5.78434V3.17954H5.6999V6.23424L7.98885 8.54131Z"
                                        fill="white" />
                                </svg>
                            </div>
                            <div class="backdrop"></div>
                            <img v-if="!clase.image" src="../../assets/claseTemp.png" alt="">
                            <img v-else :src="srcImg(clase.image)" alt="">
                        </div>
                        <div class="claseCardInfo">
                            <button class="like">
                                <svg xmlns="http://www.w3.org/2000/svg" width="26" height="25" viewBox="0 0 26 25"
                                    fill="none">
                                    <mask id="mask0_3899_5485" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0"
                                        y="0" width="26" height="25">
                                        <rect x="0.75" width="25" height="25" fill="#D9D9D9" />
                                    </mask>
                                    <g mask="url(#mask0_3899_5485)">
                                        <path
                                            d="M13.25 21.1737L12.1002 20.1401C10.3735 18.5736 8.94553 17.2275 7.81637 16.1018C6.6872 14.976 5.79241 13.974 5.13199 13.0958C4.47157 12.2179 4.0102 11.4169 3.74788 10.693C3.48538 9.96918 3.35413 9.23472 3.35413 8.48958C3.35413 7.01128 3.85256 5.77361 4.84944 4.77656C5.84649 3.77969 7.08416 3.28125 8.56246 3.28125C9.47183 3.28125 10.3312 3.49392 11.1406 3.91927C11.95 4.34462 12.6531 4.9546 13.25 5.74922C13.8468 4.9546 14.55 4.34462 15.3593 3.91927C16.1687 3.49392 17.0281 3.28125 17.9375 3.28125C19.4158 3.28125 20.6534 3.77969 21.6505 4.77656C22.6474 5.77361 23.1458 7.01128 23.1458 8.48958C23.1458 9.23472 23.0145 9.96918 22.752 10.693C22.4897 11.4169 22.0283 12.2179 21.3679 13.0958C20.7075 13.974 19.8144 14.976 18.6885 16.1018C17.5628 17.2275 16.1332 18.5736 14.3997 20.1401L13.25 21.1737ZM13.25 19.0625C14.9166 17.5628 16.2882 16.2774 17.3645 15.2063C18.4409 14.1352 19.2916 13.2048 19.9166 12.4148C20.5416 11.6249 20.9757 10.9234 21.2187 10.3104C21.4618 9.69757 21.5833 9.09062 21.5833 8.48958C21.5833 7.44792 21.2361 6.57986 20.5416 5.88542C19.8472 5.19097 18.9791 4.84375 17.9375 4.84375C17.1149 4.84375 16.3546 5.07708 15.6567 5.54375C14.959 6.01059 14.4065 6.65998 13.9992 7.49193H12.5007C12.0867 6.65321 11.5324 6.00217 10.838 5.5388C10.1435 5.07543 9.38503 4.84375 8.56246 4.84375C7.52739 4.84375 6.66098 5.19097 5.96324 5.88542C5.2655 6.57986 4.91663 7.44792 4.91663 8.48958C4.91663 9.09062 5.03815 9.69757 5.28121 10.3104C5.52427 10.9234 5.95829 11.6249 6.58329 12.4148C7.20829 13.2048 8.05899 14.1336 9.13538 15.2013C10.2118 16.269 11.5833 17.5561 13.25 19.0625Z"
                                            fill="white" />
                                    </g>
                                </svg>
                            </button>
                            <!-- <span>The Travel Guide</span> -->
                            <h5>{{ clase.method || ' ' }}</h5>
                            <p>{{ capitalizeAndLowercase(clase.title) }}</p>
                            <h6 v-if="clase.publishDate">{{ clase.publishDate.slice(0, 10) }}</h6>
                            <h6 v-else>bloqueada</h6>
                        </div>
                    </div>
                </template>


                <button v-if="this.actualPage < this.totalPages" @click="getMoreClassInfo()" class="seeMore border">
                    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="8" viewBox="0 0 17 8" fill="none">
                        <path d="M1.5 1.50006L8.5 6.50006L15.5 1.50006" stroke="#B359F8" stroke-width="1.5"
                            stroke-linecap="round" />
                    </svg>
                    <p>Ver Más</p>
                </button>
            </div>
        </div>

    </section>
</template>

<script>
import { mapActions } from 'vuex';
import { url } from '../../global/index';

import specialButtonMicro from '../specialButtonMicro.vue';

export default {
    data() {
        return {
            maxCat: 6,
            filterTop: [
                {
                    name: 'Full Body',
                    destacado: false,
                    icon: '',
                },
                {
                    name: 'Quick Full Body',
                    destacado: false,
                    icon: '',
                },
                {
                    name: 'Cardio',
                    destacado: false,
                    icon: '',
                },
                {
                    name: 'Rider Indoor Cycling',
                    destacado: true,
                    icon: require('../../assets/svg/directions_bike.svg')
                },
            ],
            searchInput: '',
            perPage: 12,
            actualPage: 1,
            totalPages: 3,
            totalClass: 0,
            cumulativeClases: [],
            showClasses: false,
            bienvenida: [
                { "id": 11, "typeId": 28, "name": "Bienvenida", "secName": null, "featured": false, "image": null, "createdAt": "2024-11-23T18:36:57.284Z", "updatedAt": "2024-11-23T18:36:57.284Z", "type": { "id": 28, "section": "fitness_class", "name": "Clases", "createdAt": "2024-11-23T18:36:57.212Z", "updatedAt": "2024-11-25T21:27:52.101Z" } }
            ],
            selectedCatCover: '',
        };
    },
    components: {
        specialButtonMicro
    },
    async created() {
        this.getClassInfo();
        const response = await this.getAllInfoCtg(`category?type=fitness_class&pageSize=1000`);
    },
    computed: {
        allClases() {
            const data = this.$store.getters['clases/data'];
            if (!Array.isArray(data.data) || data.data.length === 0) return [];

            return data;

        },
        categoriesQuery() {
            const data = this.$store.getters['categories/data'];
            return data.data;
        },
        isClasesRoute() {
            return this.$route.fullPath === '/web-app?a=clases';
        }
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll);
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
        ...mapActions('clases', ['getAllInfoCls']),
        ...mapActions('categories', ['getAllInfoCtg']),

        async getClassInfo() {
            let url = `class/paginated?page=${this.actualPage}&pageSize=12&sortByPublished=true`;

            if (this.$route.query.search) {

                url += `&name=${encodeURIComponent(this.$route.query.search)}`;
            }
            if (this.$route.query.c) {
                url += `&categories=${this.$route.query.c}`;
            }

            const response = await this.getAllInfoCls(url);
            if (response.data === null) return [];

            this.totalClass = response.data.totalAllProducts
            this.totalPages = response.data.totalPages
            this.cumulativeClases = response.data.data
        },
        async getMoreClassInfo() {
            this.actualPage++

            let url = `class/paginated?page=${this.actualPage}&pageSize=12&sortByPublished=true`
            if (this.$route.query.search) {

                url += `&name=${encodeURIComponent(this.$route.query.search)}`;
            }
            if (this.$route.query.c) {
                url += `&categories=${this.$route.query.c}`;
            }


            const response = await this.getAllInfoCls(url);

            const clasesBatch = response.data.data

            this.cumulativeClases = [...this.cumulativeClases, ...clasesBatch]
        },
        toggleMaxCat() {
            this.maxCat = this.maxCat === 6 ? 200 : 6;
        },
        linkTo(enlace) {
            const query = enlace;
            if (query) {
                const currentQuery = this.$route.query.a;

                // Verifica si la búsqueda actual es la misma que la nueva búsqueda
                if (query !== currentQuery) {
                    this.$router.push({ path: '/web-app', query: { a: query } });
                    document.getElementById('up').scrollIntoView();

                } else {
                    console.log('Ya te encuentras en este enlace');
                }
            } else {
                console.log('No se recibio link');
            }
        },
        capitalizeAndLowercase(str) {
            if (!str) return ''; // Verifica que el string no sea nulo o vacío

            // Busca la primera letra alfabética
            const firstAlphaIndex = [...str].findIndex(char => /[a-zA-Z]/.test(char));

            if (firstAlphaIndex === -1) return str.toLowerCase(); // No hay letras, solo convierte todo a minúsculas

            // Construye el nuevo string
            return (
                str.slice(0, firstAlphaIndex) + // Parte inicial, incluyendo símbolos
                str[firstAlphaIndex].toUpperCase() + // Primera letra alfabética en mayúscula
                str.slice(firstAlphaIndex + 1).toLowerCase() // Resto en minúscula
            );
        },
        srcImg: function (img) {
            if (!img || img == "") {
                return "";
            }
            let src = `${url}/class-image/${img}`;

            return src;
        },
        srcImgCat: function (img) {
            if (!img || img == "") {
                return "";
            }
            let src = `${url}/category-image/${img}`;

            return src;
        },
        searchItem() {
            this.openMenuMovil = false
            const query = this.normalizeText(this.searchInput);
            if (query === '') {
                this.removeSearch();
            }
            if (query) {
                const currentQuery = this.$route.query.search;

                // Verifica si la búsqueda actual es la misma que la nueva búsqueda
                if (query !== currentQuery) {
                    this.$router.push({ path: '/web-app', query: { a: 'clases', search: query } });
                } else {
                    console.log('Ya estás viendo los resultados de esta búsqueda');
                }
            } else {
                console.log('El campo de búsqueda está vacío');
            }
            this.showClasses = true;
        },
        normalizeText(texto) {
            const normal = texto
                .toLowerCase()
                .replace(/\s+/g, '-');

            return normal;
        },
        deNormalizeText(texto) {
            if (texto) {
                const original = texto.replace(/-/g, ' ')

                return original;
            }
        },
        async resetClassInfo() {
            this.actualPage = 1;  // Volver a la primera página
            this.cumulativeClases = [];  // Limpiar las clases acumuladas
            this.totalClass = 0;  // Resetear el total de clases
            this.totalPages = 0;  // Resetear las páginas totales
        },
        removeSearch() {
            this.$router.push({ path: '/web-app', query: { a: 'clases' } });
        },
        handleScroll() {
            const scrollPosition = window.scrollY + window.innerHeight;
            const documentHeight = document.documentElement.scrollHeight;

            // Compara si el usuario está cerca del final de la página
            if (scrollPosition >= documentHeight - 300 && !this.methodCalled) {
                this.methodCalled = true;  // Marca que el método ya ha sido llamado
                this.getMoreClassInfo();         // Llama al método cuando está cerca del final
            } else if (scrollPosition < documentHeight - 300 && this.methodCalled) {
                // Restablecer la bandera cuando el usuario vuelve a subir
                this.methodCalled = false;
            }
        },
        goToClass(className, id, locked) {
            if (locked === true) {
                return
            }
            const element = document.getElementById("top");
            element.scrollIntoView();
            const idClass = id
            const nameClass = this.normalizeText(className)
            this.$router.push({ path: '/web-app', query: { a: 'clase', id: idClass, cN: nameClass } });
        },
        navigateToCategory(cat) {
            console.log(cat)
            if (cat.cover !== null) {
                this.selectedCatCover = cat.cover;
            }
            if (this.$route.query.c !== cat.id.toString()) {
                this.showClasses = true;
                this.$router.push({ path: '/web-app', query: { ...this.$route.query, c: cat.id, cN: cat.name } });
            } else {
                console.log('Ya estás viendo esta categoría');
            }
        },
        clearCategoryAndShowClasses() {
            if (this.$route.query.c !== null || this.$route.query.cN !== 'Todas las clases') {
                this.$router.push({ path: '/web-app', query: { ...this.$route.query, c: null, cN: 'Todas las clases' } });
            }
            this.showClasses = true;
        },

    },
    watch: {
        '$route.query.search': {
            handler(newVal, oldVal) {
                this.resetClassInfo();
                this.getClassInfo()
            },
            immediate: true
        },
        '$route.query.c': {
            handler(newVal, oldVal) {
                this.resetClassInfo();
                this.getClassInfo()
            },
            immediate: true
        },
    },

};
</script>

<style scoped>
section {
    padding: 0 !important;
}

.goBack {
    display: flex;
    width: 100%;
    align-items: center;
    gap: 1.041667vw;
    cursor: pointer;
    width: fit-content;
}

.goBack svg {
    width: .620069vw;
    height: 1.736111vw;
    flex-shrink: 0;
}

.goBack p {
    overflow: hidden;
    color: var(--Text, #464D5B);
    text-overflow: ellipsis;
    font-family: Manrope;
    font-size: 1.25vw;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
}

.classListHead {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}

.search {
    display: flex;
    flex-direction: row;
    height: 3.472222vw;
    width: 23.958333vw;
    border-radius: 20.833333vw;
    border: .069444vw solid #E3E3E9;
    padding: 0 1.041667vw;
}

.search input {
    border: 0;
    background-color: transparent;
    height: 100%;
    width: 100%;

    color: var(--Text, #464D5B);
    font-family: Manrope;
    font-size: 1.041667vw;
    font-style: normal;
    line-height: normal;
    font-weight: 600;

}

.search input::placeholder {
    font-weight: 300;

}

.search svg {
    width: 2.430556vw;
    height: 2.430556vw;
}

.listInfo {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8.263889vw;
}

.listInfo p {
    color: var(--Text, #464D5B);
    font-family: Manrope;
    font-size: .694444vw;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    font-variant-numeric: tabular-nums;
}

.classListCont {
    display: flex;
    flex-direction: row;
    gap: 2.083333vw;
}

.filters {
    width: 23.958333vw;
    gap: 1.388889vw;
    height: 92vh;
    display: flex;
    flex-direction: column;
    position: sticky;
    top: 1.388889vw;
}

.filters h5 {
    color: var(--Text, #464D5B);
    font-family: Manrope;
    font-size: 1.736111vw;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}


.filtersRelevant {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: .694444vw;
}

.relevantFilter {
    display: flex;
    padding: .694444vw 1.388889vw;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: .694444vw;
    border-radius: 20.833333vw;
    border: .069444vw solid var(--Text, #464D5B);
}

.spetial {
    border: 0;
    background: var(--gradient-2, linear-gradient(90deg, #4536EF 23.52%, #FF00B8 91.32%));
}

.spetial img {
    width: 1.111111vw;
    height: 1.111111vw;
    filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(137deg) brightness(102%) contrast(102%);
}

.spetial p {
    color: #fff !important;
}

.relevantFilter p {
    color: var(--Text, #464D5B);
    text-align: center;
    font-family: Manrope;
    font-size: 1.041667vw;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.cardInfo {
    display: flex;
    padding: 1.388889vw 1.041667vw 0;
    flex-direction: column;
    align-items: center;
    flex: 1 0 0;
    align-self: stretch;
    border-radius: 2.083333vw;
    border: .069444vw solid var(--background-gray, #E3E3E9);
    height: 31.2vh;
}

.catList::-webkit-scrollbar {
    -webkit-appearance: none;
}

.catList::-webkit-scrollbar:vertical {
    width: 0.3645833333333333vw;
    background-color: #b8b8b8;
    border-radius: 1.0416666666666665VW;
}

.catList::-webkit-scrollbar-button:increment,
.catList::-webkit-scrollbar-button {
    display: none;
}

body::-webkit-scrollbar:horizontal {
    height: 0.3645833333333333vw;
}

.catList::-webkit-scrollbar-thumb {
    background-color: #8154ffb7;
    border-radius: 1.0416666666666665VW;
}

.catList::-webkit-scrollbar-track {
    border-radius: 0.3645833333333333vw;
}


.cardInfoHead {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
}

.cardInfoHead button {
    display: flex;
    padding: .694444vw 1.388889vw;
    justify-content: space-between;
    gap: 1.215278vw;
    border-radius: 20.833333vw;
    border: .069444vw solid var(--Text, #6f7177);
    align-items: center;
    width: 10.590278vw;
}

.cardInfoHead button p {
    color: var(--Text, #464D5B);
    text-align: center;
    font-family: Manrope;
    font-size: .833333vw;
    font-style: normal;
    font-weight: 400;
    text-wrap: nowrap;
    line-height: normal;
}

.cardInfoHead button svg {
    width: .625vw;
    height: .972222vw;
}

.catList {
    display: flex;
    flex-direction: column;
    width: 100%;
    overflow-y: auto;
    margin-top: 1vw;
}

.cat {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: .4vw;
    gap: .694444vw;
    border-bottom: #E3E3E9 solid .069444vw;

}

.cat p {
    color: var(--Text, #464D5B);
    font-family: Manrope;
    font-size: 1.041667vw;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    text-wrap: nowrap;
}

.cat img {
    display: block;
}

.cat.featured p {
    font-family: Manrope;
    font-size: 1.041667vw;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    background: var(--gradient-2, linear-gradient(90deg, #4536EF 23.52%, #FF00B8 91.32%));
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.cat.featured img {
    display: block;
}

.cat.featured svg {
    display: none;
}

.cat img {
    min-width: 1.541667vw;
    min-height: 1.180556vw;
}

.cat svg {
    min-width: 1.041667vw;
    min-height: 1.25vw;
}

.margLeft {
    margin-left: auto;
}

.seeMore {
    width: 100%;
    height: 10.166667vw;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: .555556vw
}

.seeMore p {
    text-align: center;
    font-family: Manrope;
    font-size: .833333vw;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    background: var(--gradient-2, linear-gradient(90deg, #4536EF 23.52%, #FF00B8 91.32%));
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.clasesList {
    width: 69.791667vw;
    min-height: 2.083333vw;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: .555556vw;
    position: relative;
    align-content: flex-start
}

.border {
    background-color: #fff;
    z-index: 10;
    border: .069444vw solid #E3E3E9;
    border-top: 0vw;
    border-radius: 0 0 1.388889vw 1.388889vw;
    bottom: 0;
    left: 0;
    height: 4.861111vw;
}

.claseCard {
    width: 16.427083vw;
    height: 17.361111vw;
    border: .069444vw solid #E3E3E9;
    border-radius: 1.388889vw;
    overflow: clip;
    display: flex;
    flex-direction: column;

}

.claseCard.bloqueada {
    filter: opacity(0.3) grayscale(1);
    pointer-events: none;
    user-select: none;

}

.claseCardImg {
    height: 10.972222vw;
    position: relative;
    cursor: pointer;
}

.claseCardImg img {
    position: absolute;
    height: 100%;
    width: 100%;
    object-fit: cover;
    z-index: 2;
}

.clasePlay {
    position: absolute;
    top: .694444vw;
    left: 1.041667vw;
    z-index: 6;
}

.clasePlay svg {
    width: .833333vw;
    height: 1.597222vw;
}

.claseDificulty {
    position: absolute;
    top: 1.094444vw;
    right: .694444vw;
    z-index: 6;
    display: flex;
    gap: .208333vw;
    flex-direction: row;
}

.claseDificulty svg {
    width: .763889vw;
    height: .902778vw;
}

.claseTime {
    position: absolute;
    bottom: .694444vw;
    right: .694444vw;
    z-index: 6;
    display: flex;
    gap: .208333vw;
    flex-direction: row;
    align-items: center;

}

.claseTime p {
    color: var(--Text, #464D5B);
    text-align: right;
    font-family: Manrope;
    font-size: .694444vw;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
}

.claseTime svg {
    width: .763889vw;
    height: .763889vw;
}

.backdrop {
    background: linear-gradient(180deg, rgba(70, 77, 91, 0.00) 27.78%, rgba(70, 77, 91, 0.20) 85.56%);
    height: 100%;
    width: 100%;
    z-index: 3;
    position: absolute;
}

.claseCardInfo {
    background: #E3E3E9;
    position: relative;
    padding: .694444vw;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: .347222vw;
    flex: 1;

}

.claseCardInfo span {
    font-family: Manrope;
    font-size: .694444vw;
    font-style: normal;
    font-weight: 600;
    line-height: normal;

    background: var(--gradient-2, linear-gradient(90deg, #4536EF 23.52%, #FF00B8 91.32%));
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    width: fit-content;
}

.claseCardInfo p {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    align-self: stretch;
    overflow: hidden;
    color: var(--Text, #464D5B);
    text-overflow: ellipsis;
    font-family: Manrope;
    font-size: .833333vw;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    height: 2lh;
}

.claseCardInfo h5 {
    font-family: "SharpGrotesk-Medium25";
    font-size: .694444vw;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    text-transform: uppercase;
    background: var(--gradient-2, linear-gradient(90deg, #4536EF 23.52%, #FF00B8 91.32%));
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    width: fit-content;

}

.claseCardInfo h6 {
    color: var(--Text, #464D5B);
    text-align: right;
    font-family: Manrope;
    font-size: .694444vw;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.like {
    position: absolute;
    top: .486111vw;
    right: .694444vw;
}

.like svg {
    width: 1.736111vw;
    height: 1.736111vw;
}

.disabled {
    filter: contrast(0);
}

.searchThing {
    display: flex;
    padding: .625vw 1.388889vw;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: .694444vw;
    flex-shrink: 0;

    border-radius: 20.833333vw;
    border: .069444vw solid var(--purple, #B359F8);

}

.searchThing p {
    color: var(--purple, #B359F8);
    text-align: center;
    font-family: Manrope;
    font-size: .694444vw;
    font-style: normal;
    font-weight: 400;
    line-height: normal;

}

.notFound {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 1.388889vw;
    width: 100%;
}

.notFound svg {
    width: 8.199931vw;
    height: 8.199931vw;
    flex-shrink: 0;
}

.notFound p {
    text-align: center;
    font-family: Manrope;
    font-size: 1.25vw;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    background: var(--gradient-2, linear-gradient(90deg, #4536EF 23.52%, #FF00B8 91.32%));
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.notFound button {
    color: var(--purple, #B359F8);
    text-align: center;
    font-family: Manrope;
    font-size: 1.041667vw;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-decoration-skip-ink: none;
    text-decoration-thickness: auto;
    text-underline-offset: auto;
    text-underline-position: from-font;
}

.catNames {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: .555556vw;
    width: 70%;
}

.catNames p {
    text-wrap: nowrap;
    background: var(--gradient-2, linear-gradient(90deg, #4536EF 23.52%, #FF00B8 91.32%));
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.catNames span {
    text-align: left !important;

    color: var(--Text, #464D5B);
    text-align: center;
    font-family: Manrope;
    font-size: .833333vw;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    text-overflow: ellipsis;
    text-wrap: nowrap;
    overflow: hidden;

    background: var(--gradient-2, linear-gradient(90deg, #4536EF 23.52%, #FF00B8 91.32%));
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.mov {
    display: none;
}

.pc {
    display: flex;
}



@media (max-width: 530px) {
    .mov {
        display: flex;
    }

    .pc {
        display: none;
    }

    .goBack {
        width: 100%;
    }

    .goBack p {
        width: 100%;
        text-align: center;

        color: var(--Text, #464D5B);
        font-family: Manrope;
        font-size: 4.186047vw;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }

    .goBack svg {
        width: 3.255814vw;
        height: 3.255814vw;
    }

    section {
        gap: 4.651163vw !important;
    }

    .listInfo {
        display: none;
    }



    .filters {
        width: 100%;
        gap: 4.651163vw;
        padding-top: 13.953488vw
    }

    .filters h5 {
        color: var(--Text, #464D5B);
        font-family: Manrope;
        font-size: 5.813953vw;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .clasesList {
        display: flex;
    }

    hr {
        display: block;
        background-color: #E3E3E9;
        border: 0;
        height: .232558vw;
    }

    .classListHead {
        position: absolute;
        left: 2.5vw;
        top: 20.930233vw;
        width: 95vw;
        overflow: hidden;
        z-index: 10;
    }

    .search {
        position: relative;
        width: 100%;
        height: 11.627907vw;
        padding: 0 3.488372vw;
        top: 0;
        transition: all 250ms ease;
        z-index: 10;
    }

    .clasesList {
        gap: 2.325581vw
    }

    .search.hideOnTop {
        top: -11.627907vw;
    }

    .search input {
        color: var(--Text, #464D5B);
        font-family: Manrope;
        font-size: 3.488372vw;
        font-style: normal;
        font-weight: 300;
        line-height: normal;
    }

    .search svg {
        width: 8.139535vw;
        height: 8.139535vw;
    }

    .cardInfo {
        border-radius: 6.976744vw;
        display: flex;
        padding: 4.651163vw 3.488372vw 0;
        margin-bottom: 18.604651vw;
    }

    .cardInfoHead {
        gap: 3.488372vw;
    }

    .cardInfoHead button {
        padding: 2.325581vw 4.651163vw;
        width: 100%;
    }

    .cardInfoHead button p {
        color: var(--Text, #464D5B);
        text-align: center;
        font-family: Manrope;
        font-size: 3.488372vw;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .cardInfoHead button svg {
        width: 3.255814vw;
        height: 3.255814vw;
    }

    .filtersRelevant {
        gap: 2.325581vw;
    }

    .filtersRelevant button {
        padding: 2.325581vw 4.651163vw;
        width: fit-content;
        gap: 3.488372vw;
    }

    .relevantFilter p {
        font-size: 3.488372vw;
    }

    .filtersRelevant button img {
        width: 3.72093vw;
        height: 3.72093vw;
    }

    .cat p {
        color: var(--Text, #464D5B);
        font-family: Manrope;
        font-size: 3.488372vw;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
    }

    .cat svg {
        min-width: 3.488372vw;
        min-height: 3.953488vw;
    }

    .catNames span {
        color: var(--Text, #464D5B);
        text-align: center;
        font-family: Manrope;
        font-size: 2.790698vw;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .catNames {
        gap: 2.325581vw;
    }

    .cat {
        padding: 1.860465vw;
        gap: 3.488372vw
    }

    .cat.featured p {
        font-family: Manrope;
        font-size: 3.488372vw;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
    }

    .seeMore {
        min-height: 11.627907vw;
        border: 0;
    }

    .seeMore p {
        font-size: 2.790698vw;
    }

    .clasesList {
        width: 92.5vw;
        background-color: #fff;
        gap: 3.488372vw;
        padding: 3.488372vw;
        border-radius: 6.976744vw;
        border: .232558vw solid var(--background-gray, #E3E3E9);
        background: #FFF;
        margin-bottom: 18.604651vw
    }

    .claseCard {
        width: 40.581395vw;
        height: auto;
        border-radius: 4.651163vw;

    }

    .claseCardImg {
        min-height: 30vw;
    }

    .claseCardInfo {
        min-height: 23.953488vw;
    }

    .classListCont {
        flex-direction: column;
    }

    .titleCard {
        height: 54.418605vw;
        width: 100%;
        display: flex;
        padding: 3.488372vw;
        flex-direction: column;
        align-items: flex-start;
        align-self: stretch;
        position: relative;
    }

    .titleCard img {
        position: absolute;
        left: 0;
        top: 0;
        z-index: -2;
        width: 100%;
    }

    .titleCard p {
        align-self: stretch;

        font-family: Kemio;
        font-size: 12.093023vw;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        /* 13.023256vw */
        text-transform: uppercase;

        background: var(--gradient-2, linear-gradient(90deg, #4536EF 23.52%, #FF00B8 91.32%));
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }

    .clasePlay {
        top: 2.325581vw;
        left: 2.325581vw;
    }

    .clasePlay svg {
        width: 2.790698vw;
        height: 5.348837vw;
    }

    .claseDificulty svg {
        width: 2.55814vw;
        height: 3.023256vw;
    }

    .claseDificulty {
        top: 2.325581vw;
        right: 2.325581vw;
    }

    .claseTime {
        bottom: 2.325581vw;
        right: 2.325581vw;
        gap: 1.162791vw;
    }

    .claseTime svg {
        width: 2.763889vw;
        height: 2.763889vw;
    }

    .claseTime p {
        color: var(--White, #FFF);
        text-align: right;
        font-family: Manrope;
        font-size: 2.325581vw;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }

    .claseCardInfo {
        padding: 2.325581vw;
    }

    .claseCardInfo h6 {
        color: var(--Text, #464D5B);
        text-align: right;
        font-family: Manrope;
        font-size: 2.325581vw;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .claseCardInfo p {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        align-self: stretch;

        overflow: hidden;
        color: var(--Text, #464D5B);
        text-overflow: ellipsis;
        font-family: Manrope;
        font-size: 2.790698vw;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }

    .hideThisSection {
        display: none;
    }

}
</style>